export const MAX_EXPORT_RECORDS = 10000;

export const filterUsersList = (userList, { role = '', search = '', selectedGroups = [] } = {}) => {
  if (!Array.isArray(userList)) {
    return [];
  }

  const selectedDirList = selectedGroups || [];

  const filterUsers = userList.filter((row) => {
    const splitGroups = (row.group || '').split(',');
    if (role !== '' && search !== '' && selectedDirList.length) {
      return (
        selectedDirList.every((selectedDir) => splitGroups.includes(selectedDir))
        && row.displayName.toLowerCase().includes(search.toLowerCase())
        && row.role === role
      );
    }
    if (role !== '' && search !== '') {
      return (
        row.displayName.toLowerCase().includes(search.toLowerCase())
        && row.role === role
      );
    }
    if (role !== '' && selectedDirList.length) {
      return (
        row.role === role
        && selectedDirList.every((selectedDir) => splitGroups.includes(selectedDir))
      );
    }
    if (search !== '' && selectedDirList.length) {
      return (
        row.displayName.toLowerCase().includes(search.toLowerCase())
        && selectedDirList.every((selectedDir) => splitGroups.includes(selectedDir))
      );
    }
    if (role !== '') {
      return row.role === role;
    }
    if (search !== '') {
      return row.displayName.toLowerCase().includes(search.toLowerCase());
    }
    if (selectedDirList.every((selectedDir) => splitGroups.includes(selectedDir))) {
      return row;
    }
    return false;
  });

  if (selectedDirList.length > 0 || role !== '' || search !== '') {
    return filterUsers;
  }

  return userList;
};

export const mapUserToExportRow = (user) => ({
  Name: user.displayName || '',
  Email: user.mail || '',
  Group: user.group || '',
  Created: user.created_date || '',
  Modified: user.last_modified_date || '',
  'Last Login': user.last_login_date || ''
});

export const hasActiveUserFilters = (filters = {}) => {
  const { role = '', search = '', selectedGroups = [] } = filters;
  return Boolean(role || search || (Array.isArray(selectedGroups) && selectedGroups.length > 0));
};

const getTimestamp = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  return `${year}${month}${day}_${hours}${minutes}`;
};

export const buildExportFilename = (filters = {}) => {
  const base = `Users_Export_${getTimestamp()}`;

  if (hasActiveUserFilters(filters)) {
    return `${base}_filtered.xlsx`;
  }

  return `${base}.xlsx`;
};

export const validateExportRecordCount = (count) => {
  if (count > MAX_EXPORT_RECORDS) {
    throw new Error('Too many records; narrow filters');
  }
};
